module.exports = __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-17c1f28437dafc4d844d30b69ff9bb99.woff";